export function getDocChanges(docChanges) {
  const updates = {
    added: [],
    modified: [],
    removed: [],
  };

  docChanges.forEach((change) => {
    if (change.type === "added") {
      updates.added.push({ uid: change.doc.id, ...change.doc.data() });
    }
    if (change.type === "modified") {
      updates.modified.push({ uid: change.doc.id, ...change.doc.data() });
    }
    if (change.type === "removed") {
      updates.removed.push({ uid: change.doc.id, ...change.doc.data() });
    }
  });
  return updates;
}
